import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "b9fb1629-a6c7-421b-8c1f-b002da2049a2",
    content: "Answer A",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-1-answer-a.svg` },
  },
  {
    id: "44df13b2-4217-4250-b4c0-d9ff16e65dbd",
    content: "Answer B",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-1-answer-b.svg` },
  },
  {
    id: "ad50bbed-51bd-4f7d-b61b-a3c0a35c1882",
    content: "Answer C",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-1-answer-c.svg` },
  },
  {
    id: "a2399aba-da67-4b2d-8e51-2a471d182046",
    content: "Answer D",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-1-answer-d.svg` },
  },
];

export const task: Task = {
  id: "a679cce9-caa4-47d1-829a-c5d25db4c90d",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["44df13b2-4217-4250-b4c0-d9ff16e65dbd"],
};
